// Fun, kid-friendly colour themes for Playground profile pages.
export const THEME_PRESETS = [
  { name: "bubblegum", label: "Bubblegum", primary: "#FF5A79", accent: "#FFC02D", bg: "#FFF0F3" },
  { name: "ocean", label: "Ocean", primary: "#2AB7CA", accent: "#2EC4B6", bg: "#EAF8FB" },
  { name: "sunshine", label: "Sunshine", primary: "#FB8500", accent: "#FFB703", bg: "#FFF8E8" },
  { name: "mint", label: "Mint", primary: "#2EC4B6", accent: "#8AC926", bg: "#ECFBF6" },
  { name: "grape", label: "Grape", primary: "#9B5DE5", accent: "#F15BB5", bg: "#F5EEFE" },
  { name: "blueberry", label: "Blueberry", primary: "#3A86FF", accent: "#8338EC", bg: "#EEF2FF" },
];

export const DEFAULT_THEME = THEME_PRESETS[0];

export function themeGradient(theme) {
  const t = theme || DEFAULT_THEME;
  return `linear-gradient(135deg, ${t.primary}, ${t.accent})`;
}
